import React from 'react';
import { device } from '../../styles/stylesheets';

import {
  Container,
  SliderCustom,
  ButtomPrevious,
  ButtomNext,
  Medal,
  IconOctopus,
  Title,
  Description,
} from './styles';

function ContainerStepHelp() {
  return (
    <Container>
      <SliderCustom
        draggable
        hasArrows
        hasDots
        arrows={{
          prev: '#StepHelpPrev',
          next: '#StepHelpNext',
        }}
        componentPrevious={<ButtomPrevious>«</ButtomPrevious>}
        componentNext={ButtomNext}
        duration={0.5}
        scrollLock
        scrollLockDelay={250}
        slidesToShow={1}
        slidesToScroll="auto"
        responsive={[{
          breakpoint: device.screen.laptopL,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 'auto',
          },
        }, {
          breakpoint: device.screen.laptop,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 'auto',
          },
        }, {
          breakpoint: device.screen.tablet,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 'auto',
          },
        }]}
      >
        <Medal>
          <IconOctopus />
          <Title>Abra seu pedido</Title>
          <Description>
            Escolha o serviço que você precisa e preencha o formulário. Quanto mais detalhes
            você informar, mais rápido enviaremos alguém pra te ajudar!
          </Description>
        </Medal>
        <Medal>
          <IconOctopus />
          <Title>Análise do pedido</Title>
          <Description>
            Nosso time receberá seu pedido e analisaremos se a responsabilidade do serviço
            é sua ou do seu proprietário.
            <br />
            Não se preocupe, você será informado sobre todo processo.
          </Description>
        </Medal>
        <Medal>
          <IconOctopus />
          <Title>Acompanhe seu pedido</Title>
          <Description>
            Acompanhe seu pedido e converse com os profissionais pelo chat. Agende o melhor
            dia para uma visita técnica ou para execução do serviço. Lembre-se que é importante
            que você e o profissional mantenham contato pelo chat
          </Description>
        </Medal>
        <Medal>
          <IconOctopus />
          <Title>Serviço realizado</Title>
          <Description>
            Tudo pronto! Quando o serviço for realizado não esqueça de avaliar aqui o
            profissional que te atendeu. Sua avaliação é muito importante para que sempre
            tenhamos os melhores profissionais conosco!
          </Description>
        </Medal>
      </SliderCustom>
      <ButtomPrevious id="StepHelpPrev">«</ButtomPrevious>
      <ButtomNext id="StepHelpNext">»</ButtomNext>
    </Container>
  );
}

export default ContainerStepHelp;
